import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-book-seller-address-labels-components',
  templateUrl: './book-seller-address-labels-components.component.html',
  styleUrls: ['./book-seller-address-labels-components.component.scss']
})
export class BookSellerAddressLabelsComponentsComponent implements OnInit {

  labelsData: any[] = [];
  data1: any[] = [];

  repNames        = '';
  district        = '';
  taluka          = '';
  deliveryMode    = '';
  distributiveRep = '';
  stateName       = '';
  iscustomer      = 'no';

  constructor(
    private dialogref: MatDialogRef<BookSellerAddressLabelsComponentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    console.log('📥 RAW DIALOG DATA =>', this.data);

    // ✅ Support both wrapper key formats
    this.labelsData = Array.isArray(this.data?.addresslabels)
      ? this.data.addresslabels
      : Array.isArray(this.data)
        ? this.data          // ← in case raw array is passed directly
        : [];

    this.repNames        = this.data?.rep_names        ?? '';
    this.district        = this.data?.district_name    ?? '';
    this.taluka          = this.data?.taluka_name       ?? '';
    this.deliveryMode    = this.data?.delivery_mode     ?? '';
    this.distributiveRep = this.data?.distributive_reps ?? '';
    this.stateName       = this.data?.state_name        ?? '';
    this.iscustomer      = this.data?.iscustomer        ?? 'no';

    console.log('📦 labelsData received =>', this.labelsData);
    this.prepareData();
  }

  prepareData(): void {
    debugger
    if (!this.labelsData || this.labelsData.length === 0) {
      this.data1 = [];
      console.warn('⚠️ labelsData is empty — nothing to display');
      return;
    }

    this.data1 = this.labelsData.map((item: any, index: number) => {
      console.log(`ROW ${index}:`, item);

      // ✅ address: keep empty string if blank — don't hide the card
      const address = (item?.address ?? '').toString().trim();

      return {
        bse_id:      item?.bse_id      ?? '',
        name:        item?.name
                     ?? item?.bookseller_name
                     ?? item?.seller_name
                     ?? item?.title
                     ?? 'N/A',
        address:     address || '',          // empty string — template handles display
        district:    (item?.district    ?? '').toString().trim(),
        taluka:      (item?.taluka      ?? '').toString().trim(),
        state:       (item?.state       ?? '').toString().trim(),
        pincode:     (item?.pincode     ?? '').toString().trim(),
        mobile_no:   (item?.mobile_no   ?? '').toString().trim(),
        subno:       item?.subno        ?? '',
        month:       item?.month        ?? '',
        year:        item?.year         ?? '',
        book_copies: Number(item?.book_copies ?? 0),
        book_names:  item?.book_names   ?? '',
        sellertype:  item?.sellertype   ?? '',
        rep_name:    item?.rep_name     ?? '',
        DistributiveRep: item?.DistributiveRep ?? '',
      };
    });

    console.log('✅ FINAL DATA1 =>', this.data1);
  }

  print(): void {
    window.print();
  }

  close(): void {
    this.dialogref.close();
  }
}